import EqualHeight from '../../js/site/equalHeight';
import MemberPopup from '../site/member-popup';
import Fancybox from '../site/fancybox';

const $ = jQuery.noConflict();

'use strict';
const Consumers = {

	$domVideoViewMore: null,
	$domVideoLibraryBlock: null,
	allVideos: window.allVideos,
	renderVideos: 12,
	offset: 6,
	counter: 0,
	// cards
	$domCardsViewMore: null,
	$domCardsBlock: null,
	allCards: window.allCards,
	renderCards: 24,
	cardsOffset: 12,
	cardsCounter: 0,
	// alert page
	pageSlug: null,
	pageUrl: null,
	// iframe
	iframeLinks: window.iframeLinks,
	// issues
	$domIssueBlock: null,
	$domIssueLoader: null,
	page: 1,
	// vegetables
	$domVegetableBlock: null,
	$domVegetableLoader: null,
	vegetablePage: 1,
	vegetables: window.vegetables,
	//resource cards
	$domResourceCard: null,
	$domResourceViewMore: null,
	allResourceCards: window.allResourceCards,
	renderResourceCards: 24,
	ResourceCardsOffset: 12,
	cardsResourceCounter: 0,



	init: function() {
		$(window).on('load', ()=>{
			// get param from url address
			const param = MemberPopup.getUrlParameter('issue');
			// show popup
			Consumers.shopPopup(param);
		});
		this.initDom();
		this.bindEvents();
		// kosher page
		if (Consumers.pageUrl.length) {
			if (Consumers.pageSlug.val() !== 'alert_page=') {
				window.history.pushState('', '', Consumers.pageUrl.val());
			}
		}
		if ($('.js-kosher-spirit-page').length > 0 && $('.js-issue-loader').length > 0) {
			Consumers.observeLoader('.js-issue-loader', 'issue');
		}
		if ($('.js-block-vegetables').length > 0 && $('.js-vegetable-loader').length > 0) {
			Consumers.observeLoader('.js-vegetable-loader', 'vegetable');
		}
	},

	initDom: ()=>{
		Consumers.$domVideoViewMore = $('.js-video-load-more');
		Consumers.$domVideoLibraryBlock = $('.js-video-library-block');
		// cards
		Consumers.$domCardsViewMore = $('.js-cards-view-more');
		Consumers.$domCardsBlock = $('.js-cards-block');
		// alert page
		Consumers.pageSlug = $('.js-kosher-alert-slug');
		Consumers.pageUrl = $('.js-kosher-alert-url');
		// issues
		Consumers.$domIssueBlock = $('.js-block-issues');
		Consumers.$domIssueLoader = $('.js-issue-loader');
		// vegetables
		Consumers.$domVegetableBlock = $('.js-block-vegetables');
		Consumers.$domVegetableLoader = $('.js-vegetable-loader');
		// resources cards
		Consumers.$domResourceCard = $('.js-resource-card-block');
		Consumers.$domResourceViewMore = $('.js-resource-view-more');
	},

	bindEvents: ()=> {
		Consumers.$domVideoViewMore.on('click', ()=> Consumers.showVideos());
		Consumers.$domCardsViewMore.on('click', ()=> Consumers.showCards());
		Consumers.$domResourceViewMore.on('click', ()=> Consumers.showResource());
		$('.js-popup-issue').on('click', (event)=>{
			// get param
			const selectedPopup = $(event.currentTarget).data('issue');
			// show popup
			Consumers.shopPopup(selectedPopup, false);
		});
		$('.js-vegetable-card-popup-trigger').on('click', (event)=>{
			// get param
			const selectedPopup = $(event.currentTarget).data('vegetable');
			// show popup
			Consumers.showVegetablePopup(selectedPopup, false);
		});
	},

	shopPopup: (param, trigger = true)=>{
		// check url param
		if (!param || ($(`[data-issue='${param}']`).length < 1 && !Consumers.iframeLinks[param])) return;
		// prepare url
		const url = MemberPopup.$domUrl + '?issue=' + param;
		// push url address
		window.history.pushState('', '', url);
		// get iframe link
		const iframe = Consumers.iframeLinks[param];
		// append link in popup
		$('.js-issue-iframe').attr('src', iframe);
		// open popup
		if (trigger) {
			if ($(`[data-issue=${param}]`).length > 1) {
				$(`.js-popup-issue[data-issue=${param}]`).trigger('click');
			} else {
				$('.js-issue-popup').trigger('click');
			}
		}
	},

	showVegetablePopup: (param, /*trigger = true*/)=> {
		const vegetable = Consumers.vegetables.find((obj)=>{
			return obj.id === param;
		});
		// check url param
		if (!param || ($(`[data-vegetable='${param}']`).length < 1 && !vegetable)) return;
		// append values to popup
		$('.js-vegetable-popup-img').attr('src', vegetable.image);
		$('.js-vegetable-popup-name').text(vegetable.name);
		$('.js-vegetable-popup-text').html(`<span>${vegetable.content}</span>`);
		// prepare url
		// const url = MemberPopup.$domUrl + '?vegetable=' + param;
		// // push url address
		// window.history.pushState('', '', url);
		// append link in popup

		// // open popup
		// if (trigger) {
		// 	if ($(`[data-vegetable=${param}]`).length > 1) {
		// 		$(`.js-popup-vegetable[data-vegetable=${param}]`).trigger('click');
		// 	} else {
		// 		$('.js-popup-vegetable').trigger('click');
		// 	}
		// }
	},


	videoTemplate: (video)=> {
		return `
		<div class="col-lg-4 col-md-4 col-sm-6 col-6 gasp-top">
			<a class="video-library__inner"
				href="${video.videoUrl}"
				data-fancybox>
				<div class="video-library__thumbnail">
					<div class="video-library__play-icon-box">
						<span class="video-library__play-icon">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor"><!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc.--><path d="M384 256L0 32v448l384-224z"/></svg>
						</span>
					</div>
					<img src="${video.image}"
						alt="Video Image">
				</div>
				<div class="video-library__video-title">
					<h3 class="section-title section-title--custom-title">${video.title}</h3>
				</div>
			</a>
		</div>
		`;
	},

	cardTemplate: (card)=> {
		return `
			<div class="col-xl-3 col-lg-3 col-md-4 gasp-top">
				<a class="customer-guides__inner ${card.bg}" href="${card.link}">
					<div class="customer-guides__inner-content">
						<span class="logo-guides">
							<svg id="Component_11_1" data-name="Component 11 – 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="357" height="438" viewBox="0 0 357 438">
							  <defs>
								<clipPath id="clip-path">
								  <rect id="Rectangle_2210" data-name="Rectangle 2210" width="357" height="438" transform="translate(201 3033)" fill="#212227"/>
								</clipPath>
							  </defs>
							  <g id="Mask_Group_127" data-name="Mask Group 127" transform="translate(-201 -3033)" opacity="0.15" clip-path="url(#clip-path)">
								<path id="Path_4967" data-name="Path 4967" d="M362.512,181.358c-.27,100.074-81.825,181.464-181.521,181.153C81.106,362.2-.215,280.655,0,181.024.217,81.115,82.092-.471,181.665,0c99.949.474,181.115,81.87,180.846,181.357M334,181.247c.056-83.821-68.539-152.44-152.466-152.52-84.262-.08-152.855,68.236-153.03,152.41-.173,83.846,68.552,152.6,152.58,152.648C265.3,333.832,333.947,265.352,334,181.247M142.594,99.742c-19.877,0-39.754.034-59.631-.05-2.125-.009-2.641.619-2.639,2.664q.075,79.81,0,159.621c0,2.118.634,2.629,2.688,2.621,19.8-.075,39.6-.045,59.4-.045h2.653v-77.1c.878.928,1.4,1.434,1.868,1.98q31.55,36.558,63.063,73.147a4.515,4.515,0,0,0,3.826,1.791q40.585-.081,81.171-.043c.717,0,1.434-.076,2.615-.142L201.361,150.592l77.77-50.406c-17.554-.444-34.859-.478-52.165-.386a9.011,9.011,0,0,0-4.6,1.335q-37.329,24.058-74.562,48.264c-.794.515-1.625.972-2.785,1.661V99.742h-2.428" transform="translate(285 2978.281)" fill="#c9c2b5" style="mix-blend-mode: color-dodge;isolation: isolate"/>
							  </g>
							</svg>
						</span>
						<div class="customer-guides__inner-title">
							<h3 class="section-title section-title--white section-title--custom-title">${card.title}</h3>
						</div>
						<div class="customer-guides__inner-more js-cards-content">
							<span class="basic-link customer-guides__inner-link">
								<p>Learn More</p>
								<span class="basic-link-icon">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.748 45" fill="currentColor"><defs><clipPath id="a"><path d="M0 0h45v34.748H0z" data-name="Rectangle 2047"/></clipPath></defs><g data-name="Group 4381"><g clip-path="url(#a)" data-name="Group 4376" transform="rotate(90 17.374 17.374)"><path d="M45 22.475L41.855 25.7 22.751 6.43 3.392 25.959 0 22.416 22.52 0 45 22.475" data-name="Path 4908"/><path d="M22.667 17.608L36.16 31.129l-3.243 3.321-10.269-10.58-10.586 10.877-2.988-3.688 13.593-13.451" data-name="Path 4909"/></g></g></svg>
								</span>
							</span>
						</div>
					</div>
				</a>
			</div>
		`;
	},

	issueTemplate: (issue)=> {
		return `
			<div class="col-lg-3 col-md-6 gasp-top">
				<div class="spirit-issues-list__wrap">
					<div class="spirit-issues-list__inner">
						<div class="spirit-issues-list__image">
								<img class="lazy"
								src="${issue.image}"
								data-src="${issue.image}" alt="Issue Image">
						</div>
						<div class="spirit-issues-list__content">
							<h3 class="spirit-issues-list__inner-title">${issue.name}</h3>
							<div class="spirit-issues-list__inner-links">
								${issue.iframe_link ? `<a class="basic-link basic-link--magazine spirit-issues-list__inner-link spirit-issues-list__inner-link--left js-popup-issue" href="javascript:;" data-issue="${issue.id}">
									View Issue
									<span class="basic-link-icon">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.748 45" fill="currentColor"><defs><clipPath id="a">
											<path d="M0 0h45v34.748H0z" data-name="Rectangle 2047"/></clipPath></defs><g data-name="Group 4381"><g clip-path="url(#a)" data-name="Group 4376" transform="rotate(90 17.374 17.374)">
											<path d="M45 22.475L41.855 25.7 22.751 6.43 3.392 25.959 0 22.416 22.52 0 45 22.475" data-name="Path 4908"/>
											<path d="M22.667 17.608L36.16 31.129l-3.243 3.321-10.269-10.58-10.586 10.877-2.988-3.688 13.593-13.451" data-name="Path 4909"/></g></g>
										</svg>
									</span>
									</a>` : ''}
								${issue.pdf ? `<a class="basic-link basic-link--magazine spirit-issues-list__inner-link spirit-issues-list__inner-link--right" href="${issue.pdf}" target="_blank" rel="noopener">
									View PDF
									<span class="basic-link-icon basic-link-icon--external-link">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor"><!--! Font Awesome Pro 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc.-->
											<path d="M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112v320c0 44.2 35.8 80 80 80h320c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v112c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h112c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"/>
										</svg>
									</span>
								</a>` : ''}
							</div>
						</div>
					</div>
				</div>
			</div>
		`;
	},

	vegetableTemplate: (vegetable)=> {
		return `
			<div class="col-xl-3 col-lg-4 col-sm-6 search-box vegetable-guide__card">
				<div class="cards__wrap vegetable-guide__wrap">
					<div class="cards__inner js-vegetable-card-popup-trigger"  data-vegetable="${vegetable.id}">
						<div class="vegetable-guide__icon-container">
							<img class="vegetable-guide-icon"
							src="${vegetable.image}"
							alt="Vegetable image">
						</div>
						<div class="cards__content cards__content--resources">
							<h3 class="vegetable-card__inner-title section-title section-title--medium-small">${vegetable.name}</h3>
							${vegetable.content ? `
								<div class="cards__inner-more js-cards-content">
									<span class="basic-link cards__inner-link">
									Read More
										<span class="basic-link-icon">
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.748 45" fill="currentColor"><defs><clipPath id="a">
												<path d="M0 0h45v34.748H0z" data-name="Rectangle 2047"/></clipPath></defs><g data-name="Group 4381"><g clip-path="url(#a)" data-name="Group 4376" transform="rotate(90 17.374 17.374)">
												<path d="M45 22.475L41.855 25.7 22.751 6.43 3.392 25.959 0 22.416 22.52 0 45 22.475" data-name="Path 4908"/>
												<path d="M22.667 17.608L36.16 31.129l-3.243 3.321-10.269-10.58-10.586 10.877-2.988-3.688 13.593-13.451" data-name="Path 4909"/></g></g>
											</svg>
										</span>
									</span>
								</div>` : ''}
						</div>
					</div>
				</div>
			</div>
		`;
	},

	resourcesTemplate: (resourcesCards)=> {
		return `<div class="resources-company__card col-lg-3 col-md-4 col-sm-6">

		<a href="${resourcesCards.card_link}" class="resources-company__card-inner">
				<img class="resources-company__icon" src="${resourcesCards.card_image.link};" alt="Icon">
				<p class="resources-company__card--title section-title section-title--custom-title">
					${resourcesCards.card_title}
				</p>
				<div class="resources-company__card--inner-more">
				<span class="basic-link resources-company__card--inner-link">
					<p>Learn More</p>
					<span class="basic-link-icon svg-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.748 45" fill="currentColor"><defs><clipPath><path d="M0 0h45v34.748H0z" data-name="Rectangle 2047"></path></clipPath></defs><g data-name="Group 4381"><g clip-path="url(#a)" data-name="Group 4376" transform="rotate(90 17.374 17.374)"><path d="M45 22.475L41.855 25.7 22.751 6.43 3.392 25.959 0 22.416 22.52 0 45 22.475" data-name="Path 4908"></path><path d="M22.667 17.608L36.16 31.129l-3.243 3.321-10.269-10.58-10.586 10.877-2.988-3.688 13.593-13.451" data-name="Path 4909"></path></g></g></svg></span>								</span>
			</div>
		</a>
	</div>`;
	},

	appendPosts: (component, data)=> {
		switch (component) {
			case 'videos' :
				Consumers.$domVideoLibraryBlock.append(
					Consumers.videoTemplate(data)
				);
				EqualHeight.equalHeight();
				break;
			case 'cards' :
				Consumers.$domCardsBlock.append(
					Consumers.cardTemplate(data)
				);
				EqualHeight.equalHeight();
				break;
			case 'issue' :
				Consumers.appendIssue(data);
				break;
			case 'vegetable' :
				Consumers.appendVegetable(data);
				break;
			default :
				break;
		}
	},

	appendIssue: (data)=>{
		for (let i = 0; i < data.data.count; i++) {
			Consumers.$domIssueBlock.append(
				Consumers.issueTemplate(data.data.posts[i])
			);
			Fancybox.init();
			$('.js-popup-issue').on('click', (event)=>{
				// get param
				const selectedPopup = $(event.currentTarget).data('issue');
				// show popup
				Consumers.shopPopup(selectedPopup, false);
			});
			EqualHeight.equalHeight();
		}
	},

	appendVegetable: (data)=>{
		for (let i = 0; i < data.data.count; i++) {
			Consumers.$domVegetableBlock.append(
				Consumers.vegetableTemplate(data.data.posts[i])
			);
			Fancybox.init();
			$('.js-vegetable-card-popup-trigger').on('click', (event)=>{
				// get param
				const selectedPopup = $(event.currentTarget).data('vegetable');
				// show popup
				Consumers.showVegetablePopup(selectedPopup, false);
			});
			EqualHeight.equalHeight();
		}
	},

	showVideos: ()=> {
		if (Consumers.allVideos.length <= Consumers.renderVideos) {
			Consumers.renderVideos = Consumers.allVideos.length;
			// hide view more
			Consumers.$domVideoViewMore.hide();
		}

		for (let i = Consumers.offset; i < Consumers.renderVideos; i++) {
			// append video on page
			Consumers.appendPosts('videos', Consumers.allVideos[i]);
			// increment counter
			Consumers.counter++;
		}
		// set offset
		Consumers.offset = Consumers.renderVideos;
		// increment renderVideos
		Consumers.renderVideos += 3;
	},

	showCards: ()=> {
		if (Consumers.allCards.length <= Consumers.renderCards) {
			Consumers.renderCards = Consumers.allCards.length;
			// hide view more
			Consumers.$domCardsViewMore.hide();
		}

		for (let i = Consumers.cardsOffset; i < Consumers.renderCards; i++) {
			// append video on page
			Consumers.appendPosts('cards', Consumers.allCards[i]);
			// increment counter
			Consumers.cardsCounter++;
		}
		// set offset
		Consumers.cardsOffset = Consumers.renderCards;
		// increment renderVideos
		Consumers.renderCards += 8;
	},

	showResource: ()=> {
		if (Consumers.allResourceCards.length <= Consumers.renderResourceCards) {
			Consumers.renderResourceCards = Consumers.allResourceCards.length;
			// hide view more
			Consumers.$domResourceViewMore.hide();
		}

		for (let i = Consumers.ResourceCardsOffset; i < Consumers.renderResourceCards; i++) {
			Consumers.$domResourceCard.append(Consumers.resourcesTemplate(Consumers.allResourceCards[i]));
			Consumers.cardsResourceCounter++;
		}
		// set offset
		Consumers.ResourceCardsOffset = Consumers.renderResourceCards;
		// increment renderVideos
		Consumers.renderResourceCards += 8;
	},

	loadMorePosts: ()=> {
		$.ajax({
			method: 'POST',
			url: window.fwsLocalized.ajaxUrl,
			data: {
				action: 'load-more-issues',
				paged: Consumers.page + 1,
			},
			success: function(response) {
				if (response.data.count < 1) {
					Consumers.$domIssueLoader.hide();
				}
				// append posts
				Consumers.appendPosts('issue', response);
				// increment page number
				Consumers.page++;
				// hide loader
				if (parseInt(Consumers.page) === parseInt(response.data.max)) {
					Consumers.$domIssueLoader.hide();
				}
			}
		});
	},

	loadMoreVegetablePosts: ()=> {
		$.ajax({
			method: 'POST',
			url: window.fwsLocalized.ajaxUrl,
			data: {
				action: 'load-more-vegetables',
				paged: Consumers.vegetablePage + 1,
			},
			success: function(response) {
				if (response.data.count < 1) {
					Consumers.$domVegetableLoader.hide();
				}
				Consumers.vegetables = $.merge(Consumers.vegetables, response.data.posts);
				// append posts
				Consumers.appendPosts('vegetable', response);
				// increment page number
				Consumers.vegetablePage++;
				// hide loader
				if (parseInt(Consumers.vegetablePage) === parseInt(response.data.max)) {
					Consumers.$domVegetableLoader.hide();
				}
			}
		});
	},

	// load more observer
	observeLoader: (selector, component) => {
		// scroll to top of page on page load
		$(function(){
			if (component === 'issue') {
				if (Consumers.$domIssueLoader.length) {
					setTimeout(() => {
						$(window).scrollTop(0);
					}, 300);
				}
			}
			if (component === 'vegetable') {
				if (Consumers.$domVegetableLoader.length) {
					setTimeout(() => {
						$(window).scrollTop(0);
					}, 300);
				}
			}
		});
		const intersectionObserver = new IntersectionObserver(entries => {
			if (entries[0].intersectionRatio <= 0) return;
			if (component === 'issue') {
				// show loader
				Consumers.$domIssueLoader.show();
				// load more posts
				Consumers.loadMorePosts();
			}
			if (component === 'vegetable') {
				// show loader
				Consumers.$domVegetableLoader.show();
				// load more posts
				Consumers.loadMoreVegetablePosts();
			}
		}, {
			rootMargin: '0px 0px -150px 0px',
		});
		// start observing
		intersectionObserver.observe(document.querySelector(selector));
	},
};

export default Consumers;
